import React from "react";
import { formatTime, generateTimeList } from "../../utils/helpers";
import ComboBox from "../dropdown/comboBox";
import { CaretDown } from "../icon/downcaret";
import { TextInput } from "./textInput";

const timeList = generateTimeList(15);

export const TimeInput = ({
  placeholder = "",
  errors = "",
  title = "",
  time,
  setDate = () => {},
  onBlur,
  onChange,
  className = "",
  name,
}: {
  placeholder: string;
  name: string;
  errors?: string;
  title: string;
  time?: Date | null;
  onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  setDate?: (time: Date | null) => void;
  className?: string;
}) => {
  return (
    <ComboBox
      menuItems={timeList.map((timeL) => {
        return {
          name: timeL.label,
          value: timeL.value,
        };
      })}
      onSelect={(val) => {
        setDate(val);
      }}
      menuClassName="rounded-xl translate-x-[-12px] bg-white !shadow-sm border !max-w-full !max-h-[200px]"
      menuItemsClassName="!text-sm !font-bold"
      className={`w-full`}
      immediate
      position="bottom start"
    >
      <TextInput
        type="text"
        name={name}
        value={formatTime(time)}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        hasTitle
        title={title}
        errors={errors}
        containerClassName=""
        readOnly={true}
        customIcon={<CaretDown />}
        customIconPosition="right"
      />
    </ComboBox>
  );
};
